export default {
  POST_DETAIL_REPORTED_USER_INFO_REQUEST: 'APP/POST_DETAIL_REPORTED/POST_DETAIL_REPORTED_LIST_REQUEST',
  POST_DETAIL_REPORTED_USER_INFO_SUCCESS: 'APP/POST_DETAIL_REPORTED/POST_DETAIL_REPORTED_LIST_SUCCESS',
  POST_DETAIL_REPORTED_USER_INFO_ERROR: 'APP/POST_DETAIL_REPORTED/POST_DETAIL_REPORTED_LIST_ERROR',
};
